export enum Pages {
  ManageAutoPay = '/',
  AutoPayConsent = '/autopay-consent',
  AutoPayMinDue = '/autopay-mindue',
  UpdateEmail = '/update-email',
  Confirmation = '/confirmation',
  Error = '/error',
  GwAutopayIneligibleError = '/gw-autopay-ineligible-error',
  CancelMembership = 'cancel',
}
